import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class NotifyService {

    private _subject: BehaviorSubject<any>;
    observer: Observable<any>;

    constructor() {
        this._subject = new BehaviorSubject<any>(null);
        this.observer = this._subject.asObservable();
    }

    notify(data) {
        this._subject.next(data);
    }
}